import React, { useEffect, useCallback, useState, useRef, useMemo } from 'react';
import { Button, message } from 'antd';
import { getTicketOcr } from '../../service/report.js';
import { getUserAccessToken } from '../../utils/auth';

const config = process.env || {};

const textMap = {
  failure: '查验失败', // 查验失败。执行请求结果失败
  fake: '假发票', // 假发票
  ps: 'P图', // p图
  real: '已验真', // 已验真
  checking: '查验中' // 查验中
};


/**
 * 照片取证，发票验真
 * 由于图片上携带的发票数据，和图片更新后的数据字段不一致，过程中做了数据混合和多字段校验
 * @returns 
 */
export default function TicketVerify(props) {
  const [ticket, setTicket] = useState({});
  const [loading, setLoading] = useState(false);

  const ticketVerifyLabel = useMemo(() => {
    const ticketVerify = ticket?.checkStatus || ticket?.ticketVerify;
    const isVerify = textMap[ticketVerify];
    const verifyResult = ticketVerify !== 'real' ? (ticket?.scope || '') : '';
    return isVerify ? `${isVerify}${verifyResult}` : '增票验真' ;
  }, [ticket]);

  const handleVerify = useCallback(() => {
      const {  currentAgent, flowId } = props;
      if (loading) {
          return;
      }
      // 老图校验结果是ticketRecord，新图是record
      if (ticketVerifyLabel !== '增票验真') {
          const url = `/check-result?agentId=${currentAgent._id}&record=${ticket.record || ticket.ticketRecord}&carId=${ticket.lossId}&token=${window.btoa(getUserAccessToken())}`;
          window.open(`/iframe/${encodeURIComponent(url)}`)
          return;
      }
      setLoading(true);
      getTicketOcr({
          id: ticket._id,
          flowId,
          original_url: ticket.original_url,
          tenant: currentAgent.tenant._id,
          userId: ticket.lossId
      }).then((res) => {
          if (res.errCode == 0) {
              // message.success('操作成功')
          } else {
              message.error('查验失败:' + res.errCode + res.errInfo);
          }
          const result = res.result;
          const text =
              textMap[result.checkStatus] +
              (result.checkStatus !== 'real' && result.scope ? result.scope : '') ||
              result.checkStatus;
          result.checkStatus !== 'failure' && message.info(`系统鉴定结果为'${text}'`);
          setTicket({
            ...ticket,
            ...result
          })
          window.postMessage({ security: true, eventName: 'refreshPicsClassify', }, '*')
          
          setLoading(false);
      }).catch((err = {}) => {
        const { result = {} } = err;
        setTicket({
          ...ticket,
          ...result
        })
        setLoading(false);
        window.postMessage({ security: true, eventName: 'refreshPicsClassify', }, '*')
      });

  }, [ticketVerifyLabel, loading, ticket, props.currentAgent, props.flowId, props.onSuccess]);

  useEffect(() => {
    const { ticket } = props;
    setTicket(ticket || {});
  }, [props.ticket]);

  return <React.Fragment>
    <Button shape="round" onClick={handleVerify} style={{ color: ['ps', 'fake', 'failure'].includes(ticket.ticketVerify || ticket.checkStatus) ? '#F96161' : '#fff' }} size="small">{loading ? '查验中' : ticketVerifyLabel}</Button>
  </React.Fragment>
}